import { render } from "./directory-info.vue?vue&type=template&id=c5d67b24"
import script from "./directory-info.vue?vue&type=script&lang=js"
export * from "./directory-info.vue?vue&type=script&lang=js"

import exportComponent from "/home/bshipaa/sites/app.bitesizehipaa.com/bss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__